module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ralph K. Hawkins\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("Ralph K. Hawkins")]), _vm._v(" is director of the program in Religion and professor of biblical and archaeological studies at Averett University, Danville, Virginia. He is also the author of "), _c('I', [_vm._v("How Israel Became a People")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/P2RQMV/tc-custom/9781467461481.jpg?1734751852552",
      "alt": "This image is the cover for the book Discovering Exodus, Discovering Biblical Texts (DBT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Discovering Exodus, Discovering Biblical Texts (DBT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This concise introduction to the interpretation of the book of Exodus encourages in-depth study of the text and deliberate grappling with related theological and historical questions by providing a critical assessment of key interpreters and interpretative debates. It draws on a range of methodological approaches (author-, text-, and reader-centered) and reflects the growing scholarly attention to the reception history of biblical texts, increasingly viewed as a vital aspect of interpretation rather than an optional extra. ")]), _c('p', [_vm._v("Throughout "), _c('i', [_vm._v("Discovering Exodus")]), _vm._v(", Ralph Hawkins"), _c('i'), _vm._v("gives strategies for reading the book of Exodus, including archaeological criticism. He also reviews key issues raised by Exodus and connects these issues to questions of how this important Old Testament book should be interpreted today.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0